import type { ColumnsType } from "antd/es/table";
import { langPage, langTableColumns, langCommon } from "../../../locales";
import { FormConfigType } from "../../../components/editForm";
import { Button } from "antd";

const lang = langPage?.card.record;

export const DEFAULT_QUERY_DATA = {
    Email: null,
    MemberId: null,
    Mobile: null,
    Status: null,
};

export const generateQueryFormConfig = (props: any): FormConfigType => {
    return [
        {
            title: '用户邮箱',
            type: "input",
            field: "Email",
            allowClear: true,
        },
        {
            title: '手机号',
            type: "input",
            field: "Mobile",
            allowClear: true,
        },
        {
            title: langPage?.card?.memberId,
            type: "input",
            field: "MemberId",
            allowClear: true,
        },
        {
            title: '状态',
            type: "select",
            field: "Status",
            allowClear: true,
            style: { width: 200 },
            options: [
                { id: 10, name: '审核中' },
                { id: 20, name: '拒绝' },
                { id: 30, name: '取消' },
                { id: 40, name: '完成' },
            ],
        },
    ];
}

export const generateTableColumns = (props: any): ColumnsType => {
    const { operationRef } = props;
    return [
        {
            title: 'Id',
            dataIndex: "Id",
        },
        {
            title: lang?.orderNo,
            dataIndex: "OrderNo",
        },
        {
            title: langPage?.card.main.member,
            dataIndex: "Member",
            render(value, record, index) {
                return value?.Email || ''
            },
        },
        {
            title: '申请数量',
            dataIndex: "CardNum",
        },
        {
            title: '地址信息',
            dataIndex: "Address",
            width: 300,
            render(_, record) {
                return (
                    <div>
                        <div>姓名：{record.Name}</div>
                        <div>手机号：{record.Mobile}</div>
                        <div>邮编：{record.Postcode}</div>
                        <div>地址：{record.Address}</div>
                    </div>
                )
            },
        },
        {
            title: '申请费用/张',
            dataIndex: "PhysicalCardFee",
        },
        {
            title: '邮寄费用',
            dataIndex: "PhysicalCardPostage",
        },
        {
            title: '状态',
            dataIndex: "StatusString",
        },
        {
            title: '备注',
            dataIndex: "Remark",
        },
        {
            title: langTableColumns?.CreatedAtString,
            dataIndex: "CreatedAtString",
        },
        {
            title: langTableColumns?.operation,
            dataIndex: "ops",
            width: 120,
            fixed: "right",
            render: (_: any, row: any) => {
                return (
                    <div>
                        <Button size="small" type="link"
                            disabled={![20, 40].includes(row?.Status)}
                            onClick={() => operationRef?.current?.changeVisible(row, 'update')}
                        >更新</Button>
                        {
                            <Button size="small" type="link" className="pdl0"
                                disabled={[20, 40].includes(row?.Status)}
                                onClick={() => operationRef?.current?.changeVisible({ ...row, Status: null }, 'audit')}
                            >{langCommon?.approve}</Button>
                        }
                    </div>
                )
            }
        }
    ]
}


export const DEFAULT_OPERATION_DATA = {
    ExpressInfo: null,
    ExpressNumber: null,
    Id: null,
    Remark: null,
    Status: null,
}

export const generateOperationFormConfig = (props: any): FormConfigType | any => {
    const { mode, formData } = props;
    return [
        ...(mode === 'audit' ? [
            {
                title: '审核',
                type: "radio",
                field: "Status",
                options: [
                    {
                        value: 40,
                        label: '通过'
                    },
                    {
                        value: 20,
                        label: '拒绝'
                    }
                ],
                rules: [{
                    required: true,
                    message: `${langCommon?.pleaseSelect}审核状态`
                }]
            },
        ] : []),
        ...(mode === 'update' || (mode === 'audit' && formData.Status === 40) ? [
            {
                title: '快递单号',
                type: "input",
                field: "ExpressNumber",
            },
            {
                title: '快递信息',
                type: "input",
                extendType: "TextArea",
                field: "ExpressInfo",
            },
        ] : []),
        ...(mode === 'update' || (mode === 'audit' && formData.Status === 20) ? [
            {
                title: '备注',
                type: "input",
                extendType: "TextArea",
                field: "Remark",
            },
        ] : [])
    ];
}